import React from "react";
import { Layout, Menu } from "antd";
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import PeopleIcon from '@mui/icons-material/People';
import TimelineIcon from '@mui/icons-material/Timeline';
import { useNavigate, useLocation } from "react-router-dom";
import { useApp } from "../../../context/AppContext";

const { Sider } = Layout;

const Sidebar = ({ collapsed }) => {
  const { user } = useApp();
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    { key: "/lessons", icon: <OndemandVideoIcon style={{ fontSize: 20 }} />, label: "שיעורים" },
    { key: "/users", icon: <PeopleIcon style={{ fontSize: 20 }} />, label: "משתמשים", disabled: user?.role !== "admin" },
    { key: "/views", icon: <TimelineIcon style={{ fontSize: 20 }} />, label: "דו\"ח צפיות", disabled: user?.role !== "admin" },
  ];

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      trigger={null}
      width={200}
      style={{
        background: "#fff",
        direction: "rtl",
        textAlign: "right",
        borderLeft: "1px solid #f0f0f0",
      }}
    >
      <img
        src={!collapsed ? "/icon.png" : "/favicon.ico"}
        alt="icon_mashlimimplus"
        style={{
          width: collapsed ? 25 : 120,
          margin: collapsed ? "18px auto" : "12px auto",
          display: "block",
          transition: "width 0.3s, margin 0.3s"
        }}
      />

      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={({ key }) => navigate(key)}
        style={{ border: "none" }}
        items={items.filter(item => !item.disabled).map(item => ({
          key: item.key,
          icon: item.icon,
          label: item.label,
          children: item.subItems?.map(sub => ({
            key: sub.key,
            label: sub.label
          }))
        }))}
      />
    </Sider>
  );

};

export default Sidebar;
